import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button } from "@mui/material";
import { useState } from "react";
import Terms from "../../../components/Terms";
import { TermoResponsabilidade } from "../../../interfaces/entities/TermoResponsabilidade";
import { sxButton, sxButtonBack } from "./sxProps";

interface TermsAeromedicaProps {
  termo: TermoResponsabilidade;
  accessibility: any;
  handleContinue?: () => void;
  handleBack: () => void;
  justView?: boolean;
}

const TermsAeromedica: React.FC<TermsAeromedicaProps> = ({
  termo,
  accessibility,
  handleContinue,
  handleBack,
  justView = false,
}) => {

  const [checked, setChecked] = useState<boolean>(false);

  return (
    <>
      <Terms
        toggleCheck={() => setChecked((prev) => !prev)}
        terms={termo}
        justView={justView}
        acceptText={justView ? "<b>Termo de Ciência e Concordância</b>" : "Li e aceito o <b>Termo de Ciência e Concordância</b>"}
      />
      <div className="button-container">
        {!justView && <Button
          variant="contained"
          size="large"
          sx={sxButton}
          style={accessibility.buttonStyleAccessibility}
          disabled={!checked}
          onClick={handleContinue}
        >
          CONTINUAR
        </Button>}
        <Button sx={sxButtonBack} onClick={handleBack}>
          <Box component="span" mr={1}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </Box>
          Voltar
        </Button>
      </div>
    </>
  );
};

export default TermsAeromedica;